import { DEPOSITS_ENABLED } from '../constants/featureFlags';
import { nodeEnv } from '../lib/config';
import { useFeatureFlag } from './useFeatureFlag';

/**
 * Custom hook that returns whether deposits are enabled.
 * Returns true if either:
 * - The DEPOSITS_ENABLED feature flag is true
 * - The node environment is 'test' (for testing purposes)
 */
export const useDepositsEnabled = () => {
  const { value: depositsEnabled } = useFeatureFlag(DEPOSITS_ENABLED);

  // Always enable deposits in test environment
  if (nodeEnv === 'test') {
    return true;
  }

  return depositsEnabled;
};
